import React from "react";
import { OutboundLink } from "react-ga";

export function TelemarketingConsentLabel() {
	return (
		<span style={{ fontWeight: "normal", textAlign: "justify" }}>
			By providing my telephone number(s) and checking this box, I consent to receive calls, text messages, voicemails, artificial or pre-recorded voices, including artificial intelligence generated calls and texts, and/or calls and texts made using an automatic telephone dialing system or an automated system for the selection and/or dialing of telephone numbers or the playing of a recorded message, by or on behalf of Republic Finance, regarding products and services offered by Republic Finance and Column N.A., including telephonic sales calls and/or marketing communications. I authorize these telemarketing calls and texts even if I have previously included my telephone number(s) on any Do-Not-Call registry or list. I understand I am not required to provide this consent as a condition of purchasing any products or service from Republic Finance or Column N.A. I certify that I have authority to provide this consent because I am the subscriber or a non-subscriber customary user of the telephone number(s) who has authority to consent to these communications. I also agree to notify Republic Finance if my telephone number(s) changes. I have read, understand, and agree to Republic Finance’s
			<br></br>
			<OutboundLink
				eventLabel="Clicked SMS Terms of Use Link"
				rel="noopener noreferrer"
				target="_blank"
				to="/legal/text-message-policy"
			>
				Text Message (SMS) Terms of Use
			</OutboundLink>
			.
		</span>
	);
}
